import { render, staticRenderFns } from "./FtaComplexTable.vue?vue&type=template&id=223fb02d&scoped=true"
import script from "./FtaComplexTable.vue?vue&type=script&lang=js"
export * from "./FtaComplexTable.vue?vue&type=script&lang=js"
import style0 from "./FtaComplexTable.vue?vue&type=style&index=0&id=223fb02d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223fb02d",
  null
  
)

export default component.exports